import { makeObservable, observable } from 'mobx'

import {
  INotification,
  INotificationInput,
  NotificationType,
} from '~/client/graph'
import BaseModel from '~/client/src/shared/models/BaseModel'
import Guard from '~/client/src/shared/utils/Guard'

import Workflow from './Workflow'

export default class BaseNotification extends BaseModel<INotification> {
  @observable public associatedPermit: Workflow = null
  @observable public wasRead: boolean
  @observable public isArchived: boolean

  public static fromInstance(instance: BaseNotification): BaseNotification {
    const notification = new BaseNotification(
      instance.id,
      instance.recipientId,
      instance.type,
      instance.authorId,
      instance.projectId,
      instance.wasRead,
      instance.isArchived,
      instance.createdAt,
      instance.entityId,
      instance.scheduleId,
      instance.messageId,
    )
    notification.associatedPermit = instance.associatedPermit
    return notification
  }

  public static fromDto(dto: INotification): BaseNotification {
    return new BaseNotification(
      dto.id,
      dto.recipientId,
      dto.type,
      dto.authorId,
      dto.projectId,
      dto.wasRead,
      dto.isArchived,
      dto.createdAt,
      dto.entityId,
      dto.scheduleId,
      dto.messageId,
    )
  }

  public constructor(
    public id: string,
    public recipientId: string,
    public type: NotificationType,
    public authorId: string,
    public projectId: string,
    wasRead: boolean,
    isArchived: boolean,
    public createdAt: number,
    public entityId?: string,
    public scheduleId?: string,
    public messageId?: string,
  ) {
    super(id)
    this.wasRead = wasRead
    this.isArchived = isArchived
    makeObservable(this)
    Guard.againstUndefined(id, 'id')
  }

  public toDto(): INotificationInput {
    return {
      id: this.id,
      authorId: this.authorId,
      entityId: this.entityId,
      isArchived: this.isArchived,
      projectId: this.projectId,
      recipientId: this.recipientId,
      scheduleId: this.scheduleId,
      type: this.type,
      wasRead: this.wasRead,
      messageId: this.messageId,
    }
  }
}
